(() => {
  class ConfirmDiscountCompleteVisitController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        newMailorderPrescriptionsArray: $scope.ngDialogData.newMailorderPrescriptionsArray,
        discount_active: $scope.ngDialogData.discount_active
      });
      this.calculateTotal();
      this.medicationFeeTotalOriginal = angular.copy(this.medicationFeeTotal);
    }

    close() {
      this.$scope.closeThisDialog(null);
    }

    proceed() {
      if (this.medicationFeeTotal > this.medicationFeeTotalOriginal) {
        this.toastr.error("New total can't exceed the original total amount.");
        return;
      }

      var response = {
        medicationFeeTotal: this.medicationFeeTotal,
        newMailorderPrescriptionsArray: this.newMailorderPrescriptionsArray
      };
      this.$scope.closeThisDialog(response);
    }

    calculateTotal() {
      this.medicationFeeTotal = 0;
      this.newMailorderPrescriptionsArray.forEach(prescription => {
        var medicationFee = "" + prescription.medicationFee;
        medicationFee = medicationFee.replace('£', '');
        if (!medicationFee) medicationFee = "0";
        medicationFee = parseFloat(medicationFee);
        this.medicationFeeTotal = this.medicationFeeTotal + medicationFee;
      });
    }

  }

  ConfirmDiscountCompleteVisitController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog"];
  angular.module('pims').controller('ConfirmDiscountCompleteVisitController', ConfirmDiscountCompleteVisitController);
})();